import React, { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'

import { AbsoluteDiv } from 'elements/layout/AbsoluteDiv'
import { TUlProps, Ul } from 'elements/layout/Ul'

export const StyledUl = styled(Ul)`
  z-index: ${(props) => props.theme.zIndex.zIndex1};
  & > li {
    padding: 8px 0;
  }
`

type TStyledAbsoluteDivProps = { offset: string }

export const StyledAbsoluteDiv = styled(AbsoluteDiv)<TStyledAbsoluteDivProps>`
  transition: transform ease-in-out 0.3s;
  transform: translateX(${(props) => props.offset});
`

export type TTabListProps<D extends Record<string, string>> = {
  data: D
  currentTab: keyof D
} & TUlProps

/**
 * ### TabList ###
 */
export const TabList = <D extends Record<string, string>>({
  data,
  currentTab,
  children,
  ...otherProps
}: PropsWithChildren<TTabListProps<D>>): ReactElement<any, any> => {
  const tabIds: (keyof D)[] = Object.keys(data)
  const numTabs = data ? tabIds.length : null
  const offset = data && currentTab ? (tabIds.indexOf(currentTab) * 100).toString() + '%' : null

  return (
    <StyledUl {...otherProps} horizontal role="tablist">
      {data && <StyledAbsoluteDiv h="2px" w={1 / numTabs} bottom bg="darkBlue" offset={offset} />}
      {children}
    </StyledUl>
  )
}
